import { useSplitIoStore } from '@centric-os/stores/splitio/use-split-io';
import { FeatureFlags } from '@centric-os/types';

/** The typed per-family config routes roll out behind a flag; off means the generic config routes. */
export function useTypedConfigRoutes(): boolean {
  return useSplitIoStore().isFeatureOn(FeatureFlags.USE_TYPED_CONFIG_ROUTES);
}
